// @ts-ignore
// @ts-nocheck
import { AxiosError, AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import { getAccessToken } from './accessTokenServices';
import api from './api';

type ErrorData = {
  response: {
    data: {
      message: string;
    };
    status: string;
  };
};

export type BaseData = {
  suplayWay: string;
  suplayDays: string;
  suplayFrequency: string;
  numberOfDaysToSuplay: number;
  active?: boolean;
  gasReleased?: boolean;
  oracleStatus?: string;
};

export type BaseTerritoryData = {
  base: BaseData;
  friday: boolean;
  monday: boolean;
  name: string;
  saturday: boolean;
  sunday: boolean;
  thursday: boolean;
  tuesday: boolean;
  useNewRefuelRule: boolean;
  wednesday: boolean;
};

export type InstallBaseData = {
  addressCode: string;
  isSelected?: boolean;
  address: string;
  number: string;
  complement: string;
  activeDateFrom: string;
  codeHierarchy: string;
  creationDate: string;
  description: string;
  name: string;
  nickname: string;
  quantity: number;
  status: string;
  updateDate: string;
  percentageValidate?: boolean;
  dateValidate?: boolean;
  baseTerritory?: BaseTerritoryData;
};

export type ResponseData = {
  items: {
    id_evento: number;
    cia: string;
    filial: string;
    cliente: number;
    endereco: number;
    base_instalada: string;
    tipo_evento: string;
    evento: string;
    dt: string;
    creation_date: string;
  }[];
};

export type NextDateToRefuelData = {
  date: string;
};

export type GetInstallBasesOptions = {
  includeInactive?: boolean;
};

export const getInstallBases = async ({
  includeInactive = false,
}: GetInstallBasesOptions = {}): Promise<InstallBaseData[] | void> => {
  let installBases: InstallBaseData[] = [] as InstallBaseData[];
  const access_token = await getAccessToken();

  const customerSiteId = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteId'
  );

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'GET',
    headers: header,
  } as AxiosRequestConfig;

  const basesData: InstallBaseData[] = [] as InstallBaseData[];

  try {
    const response = await api.get(
      `industrial/customer/v1/customers/me/bases?customer-site-id=${customerSiteId}`,
      parameters
    );

    const adressesData = response.data;

    if (adressesData.length > 0) {
      const [address] = adressesData;
      if (address.installBase.length > 0) {
        installBases = address.installBase;
        installBases.forEach((base) => {
          const isActive = base.status?.toLocaleLowerCase() === 'a';

          if (isActive || includeInactive) {
            basesData.push({
              ...base,
              address: address.addressLine,
              number: address.addressNumber,
              complement: address.complement,
              addressCode: address.code,
            });
          }
        });
      }
    }
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      const { message } = errorResponse.response.data;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
  }
  return basesData;
};

export const getBaseTerritory = async (
  selectedBase: string
): Promise<BaseTerritoryData> => {
  const access_token = await getAccessToken();
  let basesTerritoryData: BaseTerritoryData = {} as BaseTerritoryData;

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'GET',
    headers: header,
  } as AxiosRequestConfig;

  try {
    const response = await api.get(
      `industrial/customer/v1/customers/me/bases/${selectedBase}/territory`,
      parameters
    );
    basesTerritoryData = response.data;
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      const { message } = errorResponse.response.data;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
  }

  return basesTerritoryData;
};

export const getNextDateToRefuel = async (
  addressId: string,
  baseId: string
): Promise<NextDateToRefuelData[]> => {
  const access_token = await getAccessToken();

  const responseDate: NextDateToRefuelData[] = [];

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'GET',
    headers: header,
  } as AxiosRequestConfig;

  const customerCode = localStorage.getItem(
    '@UltragazEmpresarial:customerCode'
  ) as string;

  const params = `${customerCode}/address/${addressId}/base/${baseId}`;
  const urlRequest = `logistics-operation/refuel-communication/v1/preview/customer/${params}`;

  try {
    const response = await api.get<ResponseData>(urlRequest, parameters);
    const { items } = response.data;
    let nexDate = '';
    if (items.length > 0) {
      const dateRefuel = items[items.length - 1].dt;
      nexDate = new Date(dateRefuel).toLocaleDateString('pt-BR');
      responseDate.push({
        date: nexDate,
      });
    }
    return responseDate;
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      const { message } = errorResponse.response.data;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
  }
  return responseDate;
};
